import {createAsyncThunk} from '@reduxjs/toolkit';
import type {DownloadPanelUpsellingTypes} from '@Components/download-panel/components/download-panel-upselling/download-panel-upselling.types';

interface DownloadUpsellCardResponse {
  card: DownloadPanelUpsellingTypes | null;
}

/** The backend owns the queue; the client only names the cards this design cannot use. */
export const fetchDownloadUpsellCard = createAsyncThunk('downloadDialog/fetchDownloadUpsellCard', async (cardsToSkip: DownloadPanelUpsellingTypes[], {rejectWithValue}) => {
  try {
    const response = (await window.PMW.readLocal('user/getDownloadUpsellCard', {skip: cardsToSkip})) as DownloadUpsellCardResponse;
    return response.card;
  } catch (err) {
    return rejectWithValue(err);
  }
});
